import React from 'react';
import { Helmet } from 'react-helmet';

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Μαρία Παπαδοπούλου',
      role: 'Προπονήτρια Fitness και Ιδρύτρια',
      bio: 'Με πάνω από 15 χρόνια εμπειρίας στο fitness, η Μαρία είναι πιστοποιημένη προπονήτρια και διατροφολόγος. Η αφοσίωσή της στην υγεία και την άσκηση έχει βοηθήσει εκατοντάδες ανθρώπους να επιτύχουν τους στόχους τους.',
      image: '/images/team_1.jpg'
    },
    {
      id: 2,
      name: 'Ελένη Γεωργίου',
      role: 'Ειδικός Διατροφής',
      bio: 'Η Ελένη είναι διπλωματούχος διατροφολόγος με ειδίκευση στην αθλητική διατροφή. Δημιουργεί εξατομικευμένα διατροφικά προγράμματα που βοηθούν τους πελάτες να επιτύχουν μέγιστη απόδοση.',
      image: '/images/team_2.jpg'
    },
    {
      id: 3,
      name: 'Νίκος Ανδρέου',
      role: 'Προπονητής Ενδυνάμωσης',
      bio: 'Ο Νίκος ειδικεύεται στην προπόνηση με βάρη και την ανάπτυξη μυϊκής μάζας. Με πιστοποιήσεις από διεθνή οργανισμού, φέρνει την επιστημονική προσέγγιση στο γυμναστήριο.',
      image: '/images/team_3.jpg'
    },
    {
      id: 4,
      name: 'Σοφία Νικολάου',
      role: 'Προπονήτρια Yoga και Pilates',
      bio: 'Η Σοφία συνδυάζει παραδοσιακές και σύγχρονες τεχνικές yoga και pilates για να βοηθήσει τους πελάτες να βελτιώσουν την ευελιξία, την ισορροπία και τη νοητική τους ευεξία.',
      image: '/images/team_4.jpg'
    },
    {
      id: 5,
      name: 'Δημήτρης Κωνσταντίνου',
      role: 'Προπονητής Καρδιοαναπνευστικής Αντοχής',
      bio: 'Ο Δημήτρης ειδικεύεται στην καρδιοαναπνευστική προπόνηση και τα προγράμματα αντοχής. Έχει βοηθήσει αθλητές όλων των επιπέδων να υπερβούν τα όριά τους.',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <div className="about-container">
      <Helmet>
        <title>Σχετικά με Εμάς - Ecunel Fitness Gym</title>
        <meta name="description" content="Γνωρίστε την ομάδα του Ecunel Fitness Gym. Πιστοποιημένοι προπονητές και ειδικοί υγείας αφοσιωμένοι στην επιτυχία σας." />
        <meta property="og:title" content="Σχετικά με Εμάς - Ecunel Fitness Gym" />
        <meta property="og:description" content="Γνωρίστε την ομάδα του Ecunel Fitness Gym" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "AboutPage",
            "name": "Σχετικά με το Ecunel Fitness Gym",
            "description": "Γνωρίστε την ομάδα του Ecunel Fitness Gym"
          })}
        </script>
      </Helmet>

      <div className="about-hero">
        <h1>Σχετικά με το Ecunel Fitness Gym</h1>
        <p>
          Είμαστε μια ομάδα παθιασμένων επαγγελματιών του fitness, αφοσιωμένη στο να σας βοηθήσει 
          να επιτύχετε τους στόχους σας και να ζήσετε μια πιο υγιή ζωή.
        </p>
      </div>

      <div className="about-content">
        <h2>Η Ιστορία Μας</h2>
        <p>
          Το Ecunel Fitness Gym ιδρύθηκε το 2015 με ένα απλό όραμα: να δημιουργήσουμε έναν χώρο όπου 
          άνθρωποι όλων των ηλικιών και επιπέδων φυσικής κατάστασης μπορούν να βρουν την υποστήριξη, 
          την καθοδήγηση και την έμπνευση που χρειάζονται για να επιτύχουν τους στόχους τους στο fitness.
        </p>
        <p>
          Από τότε, έχουμε εξελιχθεί σε μια από τις πιο αξιόπιστες πηγές πληροφοριών και συμβουλών για 
          την υγεία και το fitness στην Ελλάδα. Η ομάδα μας αποτελείται από πιστοποιημένους προπονητές, 
          διατροφολόγους και ειδικούς υγείας που φέρνουν συλλογικά πολλές δεκαετίες εμπειρίας.
        </p>
        <p>
          Πιστεύουμε ότι το fitness δεν είναι μόνο για το σώμα - είναι ένας ολιστικός τρόπος ζωής που 
          περιλαμβάνει τη φυσική υγεία, τη σωστή διατροφή, τη νοητική ευεξία και την κοινοτική υποστήριξη. 
          Αυτή η φιλοσοφία διαπερνά όλα όσα κάνουμε, από τα άρθρα του blog μας μέχρι τις προσωπικές μας 
          αλληλεπιδράσεις με κάθε μέλος της κοινότητάς μας.
        </p>
        <p>
          Στο Ecunel, δεν προσφέρουμε απλώς προγράμματα προπόνησης - προσφέρουμε μια μετατροπή. Είμαστε 
          εδώ για να σας υποστηρίξουμε σε κάθε βήμα του ταξιδιού σας προς μια πιο υγιή, δυνατή και 
          χαρούμενη εκδοχή του εαυτού σας.
        </p>
      </div>

      <section className="team-section">
        <h2>Η Ομάδα Μας</h2>
        <div className="team-grid">
          {teamMembers.map(member => (
            <div key={member.id} className="team-member">
              <img 
                src={member.image} 
                alt={member.name}
                width="400"
                height="400"
              />
              <div className="team-info">
                <h3>{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default About;